import React from "react";
import PdfViewer from "../../PdfViewer";

const PythonTema4 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema4_Funciones.pdf`;
  /*const pdfUrl = "/pdf/Tema4_Funciones.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Tema 4: Funciones</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PythonTema4;
